import { Student } from './../models/student';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStrorageService {
  studentKey = 'studentInfo';
  languageKey = 'currentLanguage';

  constructor() {
  }

  getStudent(): Student | undefined {
    const userAsString = localStorage.getItem(this.studentKey);
    if (!userAsString) {
      return undefined;
    }
    return JSON.parse(userAsString);
  }

  saveStudent(student: Student): any {
    const userAsString = JSON.stringify(student);
    localStorage.setItem(this.studentKey, userAsString);
  }

  deleteStudent(): any {
    localStorage.removeItem(this.studentKey);
  }

  setLang(lang): void {
    localStorage.setItem(this.languageKey, lang);
  }

  getLang(): string {
    const lang = localStorage.getItem(this.languageKey);
    if (!lang) {
      return 'kyr';
    }
    return lang;
  }
}
